let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6aY84")).then(() => parcelRequire('7YEWU'));